// src/components/KanbanColumn.js
import React from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { FiTrash2 } from 'react-icons/fi';
import TicketCard from './TicketCard';

const KanbanColumn = ({ group, tickets, isOverdueChecker, isDropDisabled = false, isStaticList = false, onDelete }) => {
    return (
        <div className="kanban-column">
            <h3 className="kanban-column-title">
                <span style={{ flexGrow: 1 }}>{group.name} <span>({tickets.length})</span></span>
                {onDelete && (
                    <button 
                        className="btn-icon-only btn-icon-danger" 
                        onClick={onDelete} 
                        title={`Delete "${group.name}" list`}
                        style={{ marginLeft: '0.5rem' }}
                    >
                        <FiTrash2 size={14} />
                    </button>
                )}
            </h3>
            <Droppable droppableId={group._id} isDropDisabled={isDropDisabled}>
                {(provided, snapshot) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        className={`kanban-ticket-list ${snapshot.isDraggingOver ? 'is-dragging-over' : ''}`}
                    >
                        {tickets.map((ticket, index) => (
                            <TicketCard
                                key={`${ticket._id}-${group._id}`} // Unique key to prevent React errors
                                ticket={ticket}
                                index={index}
                                isOverdue={isOverdueChecker(ticket)}
                                isStaticList={isStaticList}
                            />
                        ))}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </div>
    );
};

export default KanbanColumn;